import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'pw-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Pathways Health Partners',
  fillColor: '',
  welcomeText: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1,
  email: '@',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/pw/index.js